"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "formello": {
    "decd9b38": [{
      "hkey": "55d3ff8f",
      "slug": "prato-roseto-case-bianche",
      "name": "Prato Roseto-Case Bianche",
      "primary": true,
      "skipSearch": false
    }],
    "prato-roseto": [{
      "hkey": "55d3ff8f",
      "slug": "prato-roseto-case-bianche",
      "name": "Prato Roseto-Case Bianche",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;